import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useContext } from 'react';
import { withContext } from 'with-context';
export default function createContextHelpers(Context, name) {
  var _ref;
  var capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
  var Provider = Context.Provider;
  function useMethod() {
    return useContext(Context);
  }
  return _ref = {}, _defineProperty(_ref, "".concat(name, "Context"), Context), _defineProperty(_ref, "".concat(capitalizedName, "Provider"), Provider), _defineProperty(_ref, "use".concat(capitalizedName), useMethod), _defineProperty(_ref, "with".concat(capitalizedName), withContext(Context, name)), _ref;
}